@use '@/styles/tokens' as *;

/* Figma 1322:689888 — a 40px translucent blue body (`circle r=20`, #007AFF at 60%) around a 12px
 * white-ringed core, the same 40px as a Device pin so the two read as one marker family at one size.
 *
 * The translate centres the dot on the projected point: <MapOverlay> puts its box's TOP-LEFT there.
 *
 * The 40px is a CONSTANT — it is not derived from the fix's accuracy and does not resize with zoom,
 * which is what separates it from the accuracy radius the criteria forbid (113583 §4c). No --space-*
 * or size token sits at 40. */
.dot {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: $color-my-location-body;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  /* No pointer-events opt-in, deliberately: the overlay's container blocks them and clicking the dot
   * must do nothing (113584 §8f). */
}

/* Figma: `circle r=6` in Info/900 (#00449E), ringed by a 3px #FFFFFF stroke at r=7.5.
 * `--surface-card` is this project's #FFFFFF; `$color-white-100` is #FCFCFC and would drift a step
 * (see plan.md D6). The Figma drop shadow is 0 8px 12px rgba(0,0,0,0.12); $shadow-md is the nearest
 * shipped token and a new shadow token for one dot is not worth its upkeep — recorded as a deviation
 * in verification.md. */
.core {
  width: 12px;
  height: 12px;
  background: $color-info-900;
  border-radius: 50%;
  box-shadow:
    0 0 0 3px var(--surface-card),
    $shadow-md;
}
